export class EditUserAddress {
    constructor(userId: string, address: string) {
        this.userId = userId;
        this.address = address;
    }

    userId: string;
    address: string;
}
